import { PoolType } from "../types";
const isStandardPool = (pool) => pool.type === PoolType.STANDARD;
const isStablePool = (pool) => pool.type === PoolType.STABLE_PLAIN || pool.type === PoolType.STABLE_META;
const isStableMetaPool = (pool) => pool.type === PoolType.STABLE_META;
export { isStablePool, isStandardPool, isStableMetaPool };
//# sourceMappingURL=types.js.map